import React, { useContext, useEffect, useState } from 'react';
import './Pricing.css';
import * as PROJECT_CODE from '../../../constants/projectCode';
import * as STORAGE_BUCKET from '../../../constants/storageBucket';
import { FirebaseContext } from '../../../context/firebase';
import CheckIcon from '@material-ui/icons/Check';
import { useStep } from 'react-hooks-helper';
import ShowMoreText from 'react-show-more-text';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ReactPaginate from 'react-paginate';
import Checkbox from '@material-ui/core/Checkbox';
import CircleChecked from '@material-ui/icons/CheckCircleOutline';
import CircleCheckedFilled from '@material-ui/icons/CheckCircle';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CategoryList from './CategoryList';
import '../Doc.css';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	makeStyles,
	Typography,
} from '@material-ui/core';

function Pricing({
	setTotalUpgradePrice,
	setUpgradeTotalPrice,
	upgradeTotalPrice,
}) {
	const { firebase } = useContext(FirebaseContext);
	const [upgradeCategory, setUpgradeCategory] = useState([]);
	const [categoryChoice, setCategoryChoice] = useState('main');
	const [checkedItems, setCheckedItems] = useState({
		cabinetry: {},
		countertops: {},
		doorstrim: {},
		flooring: {},
		lighting: {},
		plumbing: {},
	});
	const [catId, setCatId] = useState();
	const [categoryName, setCategoryName] = useState();
	const [categoryNameId, setCategoryNameId] = useState();

	useEffect(() => {
		firebase.auth().onAuthStateChanged(function (user) {
			if (user) {
				var upgradeItemList = [];
				var upgradeTotalList = [];
				var upgradePriceArr = [];

				firebase
					.database()
					.ref(
						'/kavtek_clients/' + PROJECT_CODE.projectCode + '/buildingUpgrades/'
					)
					.on('value', (snapshot) => {
						snapshot.forEach((snap) => {
							snap.forEach((id) => {
								id.forEach((item) => {
									item.forEach((priceItem) => {
										console.log(priceItem.val().price);
										upgradePriceArr.push(priceItem.val().price);
									});
								});
							});
						});

						var upgradeSum = upgradePriceArr.reduce(function (a, b) {
							return a + b;
						}, 0);

						setTotalUpgradePrice(upgradeSum);
					});

				firebase
					.database()
					.ref(
						'/kavtek_clients/' + PROJECT_CODE.projectCode + '/buildingUpgrades/'
					)
					.orderByKey()
					.on('value', (snapshot) => {
						var upgradesLink;
						var upgradeTotalObj;
						snapshot.forEach((item) => {
							var categoryId = item.key;
							item.forEach((snap) => {
								var upgradeItem = snap.key;

								upgradeTotalList.push(upgradeTotalObj);

								console.log('upgradeItem: ' + upgradeItem);

								function getImageLinkForUpgrades(callback) {
									var imageRef = firebase
										.storage()
										.refFromURL(
											'gs://' +
												STORAGE_BUCKET.storageBucket +
												'.appspot.com/' +
												PROJECT_CODE.projectCode +
												'/upgrades/' +
												upgradeItem +
												'.png'
										);

									imageRef
										.getDownloadURL()
										.then((url) => {
											callback(url);
										})
										.catch((error) => {
											console.log(error);
										});
								}

								getImageLinkForUpgrades(function (imageLink) {
									upgradesLink = {
										id: categoryId,
										name: upgradeItem,
										categoryImage: imageLink,
									};

									upgradeItemList.push(upgradesLink);

									setUpgradeCategory([...upgradeItemList]);
									console.log('TEST: ' + upgradeItemList);
								});
							});
						});

						// setUpgradeTotal(upgradeTotalList);
						// console.log('Total list: ' + JSON.stringify(upgradeTotalList));
					});
			}
		});
	}, []);

	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	const handleCategory = (e) => {
		var categoryId = e.currentTarget.dataset.categoryid;
		var categoryName = e.currentTarget.dataset.categoryname;
		var categoryNameId = e.currentTarget.dataset.categorynameid;

		setCatId(categoryId);
		setCategoryName(categoryName);
		setCategoryNameId(categoryNameId);

		setCategoryChoice(categoryName);
	};

	// const handleCheck = (event) => {
	// 	var priceListArr = [];
	// 	var categoryId = event.currentTarget.dataset.categoryid;

	// 	setCheckedItems({
	// 		...checkedItems,
	// 		[event.target.name]:
	// 			event.target.checked === true ? event.target.value : 0,
	// 	});

	// 	if (event.target.checked === true) {
	// 		priceListArr.push(event.target.value);
	// 	}

	// 	console.log('This is checked items: ' + JSON.stringify(checkedItems));
	// 	console.log('Price list: ' + priceListArr);
	// };

	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	const showMore = () => {
		return <MoreHorizIcon />;
	};

	const useStyles = makeStyles({
		cardGroup: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		root: {
			minWidth: 400,
			margin: 10,
			cursor: 'pointer',
		},
		cardContent: {
			display: 'flex',
			flexDirection: 'row',
			marginTop: '15px',
			marginLeft: '25px',
			position: 'relative',
		},
		categoryTopTitle: {
			width: 200,
			margin: '0 18px',
			padding: '15px',
		},

		title: {
			fontSize: 34,
			marginLeft: '40px',
			marginTop: '-25px',
		},
		checkboxNone: {
			stroke: '#414D55',
			strokeWidth: '2px',
			color: '#2662f0',
			fontSize: '15px',
			strokeWidth: '3px',
			left: '-40px',
			top: '-5px',
		},
		checkbox: {
			stroke: '#2662f0',
			strokeWidth: '2px',
			color: '#2662f0',
			fontSize: '15px',
			strokeWidth: '3px',
			left: '-40px',
			top: '-5px',
		},
	});

	const styles = useStyles();

	const handleBack = () => {
		setCategoryChoice('main');
	};

	return (
		<div className='doc_card upgrades_card'>
			<div className='card_title'>
				<div className='title'>Upgrades</div>
				{/* {categoryChoice !== 'main' ? (
					<div className='backbtn'>
						<button onClick={handleBack}>Save and close</button>
					</div>
				) : null} */}
			</div>
			{categoryChoice !== 'main' ? (
				<>
					{/* <CategoryList
						categoryId={catId}
						categoryName={categoryName}
						categoryNameId={categoryNameId}
						setCategoryChoice={setCategoryChoice}
						setCheckedItems={setCheckedItems}
						checkedItems={checkedItems}
						setUpgradeTotalPrice={setUpgradeTotalPrice}
						upgradeTotalPrice={upgradeTotalPrice}
					/> */}
				</>
			) : (
				<div className='empty_state_handler'>
					You will be able to choose your upgrades after the completion of the
					sale.
				</div>
			)}
		</div>
	);
}

export default Pricing;
